module.exports = __webpack_public_path__ + "static/alameda-light-19fbe9568faeb301fc2c1d4fd59ea3f3.svg";